
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/talcum.claims/contact-us",
      function () {
        return require("private-next-pages/talcum.claims/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/talcum.claims/contact-us"])
      });
    }
  